import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { client } from "../../../../services/client";
import { recordFinalQuizAction } from "../../../../actions/quizActions";
import QuizStep from "./QuizStep";
import { LoadingTile } from "../../../../components/ui/Loading/LoadingTile";
import { useLoadingContent } from "../../../../hooks/useLoadingContent";
import { usePersistentLoading } from "../../../../hooks/usePersistentLoading";

// It's better to store IDs like this in an .env file
const FINAL_QUIZ_ID =
  process.env.REACT_APP_FINAL_QUIZ_ID || "9f033755-9689-458b-b67b-154ac6b5c819";

export default function FinalQuizHost() {
  const [quizData, setQuizData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // <-- NEW: State to track submission
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingContent = useLoadingContent();
  const { isShowing, tileProps } = usePersistentLoading(
    !quizData,
    loadingContent
  );

  useEffect(() => {
    const query = `*[_type == "quiz" && _id == $quizId][0]`;

    client
      .fetch(query, { quizId: FINAL_QUIZ_ID })
      .then(setQuizData)
      .catch((error) => {
        // <-- NEW: Added error handling
        console.error("Failed to fetch quiz data:", error);
        // Optionally, set an error state to show a message to the user
      });
  }, []);

  // NEW: Updated to be async and handle errors
  const handleSubmitScore = async (score) => {
    setIsSubmitting(true);
    try {
      // Our Redux Thunk actions return a promise, so we can await them
      await dispatch(recordFinalQuizAction(score));
      // Only navigate AFTER the dispatch is successful
      navigate("/art-of-looking-menu");
    } catch (error) {
      // If the dispatch fails, inform the user
      alert("There was an error submitting your score. Please try again.");
      console.error("Failed to submit score:", error);
      setIsSubmitting(false);
    }
  };

  if (isShowing) {
    return <LoadingTile content={loadingContent} {...tileProps} />;
  }

  // Pass `isSubmitting` to the child component so it can disable its button
  return (
    <QuizStep
      data={quizData}
      onSubmit={handleSubmitScore}
      isSubmitting={isSubmitting}
    />
  );
}
